import React, { Component } from 'react'
import { AccountStatement, Expirations, Filters } from './.'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import tabs from './tabs'
import PropTypes from 'prop-types'
import moment from 'moment'
import yn from 'yn'
import 'react-tabs/style/react-tabs.css'
import '@loyal_template/tracking.css'

class Details extends Component {
  state = {
    filterSelected: tabs[0].options[2].value,
    currentTab: tabs[0]
  }

  componentDidMount () {
    this.handleOnFilterSelect(this.state.filterSelected)

    this.handleOnFilterSelect({ startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'), endDate: moment().add(1, 'day').format('YYYY-MM-DD') })
  }

  fetchRecords = (tab, value) => {
    if (tab.name === 'AccountStatement') {
      this.props.fetchExtract(value)
    } else {
      this.props.fetchCreditToExpire(value)
    }
  }

  handleOnFilterSelect = value => {
    this.setState({ filterSelected: value })
    const { currentTab } = this.state
    this.fetchRecords(currentTab, value)
  }

  handleOnTabSelect = index => {
    const currentTab = tabs[index]
    const options = currentTab.options.slice(2, 7)
    const filterSelected = options[0].value
    this.setState({ currentTab, filterSelected })
    this.fetchRecords(currentTab, filterSelected)
  }

  render () {
    return (
      <div className='extract-summary radius bg-ui-5 row px-0 pb-2 border-bottom border-left border-color-ui-3'>
        <Tabs
          onSelect={this.handleOnTabSelect}
          className='col-12 product-tabs border-none radius-top border-color-ui-3 px-0'
        >
          <div className='row bg-white radius-top border-color-ui-3 border-bottom mx-0'>
            <div className='draggable px-2 px-md-0 pb-3'>
              <div className='draggable-item d-inline-block px-half'>
                <TabList className='tabs-item pt-3 px-1 mx-0'>
                  <div className='mx-0'>
                    <Tab className='item-button pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'>
                      Detalhe de {this.props.currency.label}
                    </Tab>
                    {
                      !yn(process.env.REACT_APP_EXPIRATION_POINTS_LABEL_DISABLED) &&
                      <Tab className='item-button pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body  color-ui-3'>
                        {this.props.currency.label} a expirar
                      </Tab>
                    }
                  </div>
                </TabList>
              </div>
            </div>
          </div>
          <Filters
            options={this.state.currentTab.options.slice(2, 7)}
            onFilterSelect={this.handleOnFilterSelect}
            filterSelected={this.state.filterSelected}
            currentTab={this.state.currentTab}
          />
          <TabPanel className='row px-3 mx-0 radius-bottom'>
            <AccountStatement {...this.props} />
          </TabPanel>
          <TabPanel className='row px-3 mx-0 radius-bottom'>
            <Expirations {...this.props} />
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

Details.propTypes = {
  fetchExtract: PropTypes.func.isRequired,
  fetchCreditToExpire: PropTypes.func.isRequired,
  currency: PropTypes.object
}

export default Details



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/Details.js